import React from "react";
import { v4 as guid } from "uuid";

export default function InputCheckbox(props) {
    const [id, setId] = React.useState(guid());

    function onChange() {
        props.onChange(props.value, !props.checked);
    }

    function onKeyUp(event) {
        const x =
            event.key === "Enter" ||
            event.keyCode === 13 ||
            // Space
            event.keyCode === 32;

        x && props.onChange(props.value, !props.checked);
    }

    const CLInputCheckbox = ["input-checkbox"];
    props.checked && CLInputCheckbox.push("checked");

    return (
        <label tabIndex={0} htmlFor={id} className={CLInputCheckbox.join(" ")} onKeyUp={onKeyUp}>
            <div className="input-checkbox-wrap">
                <input id={id} type="checkbox" onChange={onChange} checked={props.checked} />
                <div className="input-checkbox-inner"></div>
            </div>

            {props.children && <div>{props.children}</div>}
        </label>
    );
}
